var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1272,
    height: 656,
    viewBox: "0 0 1272 656",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_96_553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2158.21 429.647C2109.62 570.402 1731.57 398.625 1449.58 473.257C1167.59 547.89 1018.29 818.662 804.659 787.883C591.032 757.105 384.063 505.602 424.167 325.52C464.271 145.438 816.409 121.147 997.158 -76.5107C1177.91 -274.168 1148.92 -597.017 1291.76 -623.237C1434.6 -649.456 1502.29 -421.717 1682.8 -202.366",
    stroke: "url(#paint0_linear_96_553)",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2114.39 413.815C2068.01 548.172 1707.14 384.202 1437.97 455.443C1168.8 526.683 1026.28 785.147 822.364 755.768C618.447 726.388 420.886 486.317 459.167 314.421C497.448 142.524 833.58 119.337 1006.11 -69.3359C1178.65 -258.009 1150.98 -566.182 1287.33 -591.211C1423.67 -616.239 1488.28 -398.851 1660.59 -189.471",
    stroke: "url(#paint1_linear_96_553)",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2070.57 397.982C2026.4 525.941 1682.71 369.78 1426.36 437.627C1170 505.475 1034.27 751.632 840.068 723.651C645.862 695.671 457.708 467.032 494.167 303.321C530.625 139.61 850.75 117.527 1015.07 -62.1617C1179.38 -241.85 1153.03 -535.349 1282.89 -559.185C1412.74 -583.021 1474.27 -375.986 1638.37 -176.576",
    stroke: "url(#paint2_linear_96_553)",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2026.75 382.149C1984.79 503.711 1658.29 355.357 1414.75 419.813C1171.21 484.268 1042.27 718.117 857.773 691.535C673.277 664.954 494.531 447.747 529.166 292.222C563.802 136.696 867.921 115.717 1024.02 -54.9869C1180.12 -225.691 1155.09 -504.515 1278.45 -527.159C1401.82 -549.804 1460.27 -353.12 1616.16 -163.681",
    stroke: "url(#paint3_linear_96_553)",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1982.93 366.317C1943.18 481.48 1633.86 340.935 1403.14 401.998C1172.42 463.061 1050.26 684.602 875.477 659.419C700.692 634.237 531.354 428.462 564.166 281.122C596.978 133.782 885.091 113.908 1032.98 -47.8122C1180.86 -209.532 1157.15 -473.681 1274.02 -495.133C1390.89 -516.586 1446.26 -330.254 1593.95 -150.785",
    stroke: "url(#paint4_linear_96_553)",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1939.11 350.485C1901.56 459.25 1609.43 326.513 1391.53 384.183C1173.63 441.854 1058.26 651.087 893.182 627.303C728.106 603.52 568.176 409.177 599.166 270.023C630.155 130.868 902.262 112.098 1041.93 -40.6375C1181.6 -193.373 1159.2 -442.847 1269.58 -463.107C1379.96 -483.368 1432.26 -307.388 1571.74 -137.89",
    stroke: "url(#paint5_linear_96_553)",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1895.29 334.652C1859.95 437.019 1585 312.09 1379.92 366.368C1174.84 420.646 1066.25 617.571 910.887 595.187C755.521 572.803 604.999 389.892 634.165 258.923C663.332 127.954 919.432 110.288 1050.89 -33.4632C1182.34 -177.214 1161.26 -412.013 1265.14 -431.082C1369.03 -450.151 1418.25 -284.523 1549.53 -124.995",
    stroke: "url(#paint6_linear_96_553)",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.47 318.819C1818.34 414.789 1560.57 297.667 1368.31 348.553C1176.04 399.439 1074.25 584.056 928.591 563.071C782.936 542.086 641.821 370.607 669.165 247.823C696.509 125.04 936.603 108.478 1059.84 -26.2885C1183.08 -161.055 1163.32 -381.179 1260.71 -399.056C1358.1 -416.933 1404.25 -261.657 1527.32 -112.099",
    stroke: "url(#paint7_linear_96_553)",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1807.65 302.987C1776.73 392.558 1536.15 283.245 1356.7 330.739C1177.25 378.232 1082.24 550.542 946.296 530.955C810.351 511.369 678.644 351.322 704.165 236.724C729.685 122.126 953.773 106.668 1068.8 -19.1137C1183.82 -144.896 1165.37 -350.345 1256.27 -367.03C1347.17 -383.716 1390.24 -238.791 1505.11 -99.2038",
    stroke: "url(#paint8_linear_96_553)",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763.83 287.154C1735.12 370.327 1511.72 268.822 1345.09 312.923C1178.46 357.024 1090.23 517.026 964 498.839C837.766 480.651 715.467 332.036 739.164 225.624C762.862 119.212 970.944 104.858 1077.75 -11.9395C1184.56 -128.737 1167.43 -319.511 1251.83 -335.005C1336.24 -350.498 1376.23 -215.925 1482.9 -86.3088",
    stroke: "url(#paint9_linear_96_553)",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720.01 271.321C1693.5 348.097 1487.29 254.4 1333.48 295.109C1179.67 335.817 1098.23 483.511 981.706 466.723C865.182 449.935 752.29 312.751 774.165 214.525C796.04 116.298 988.115 103.048 1086.71 -4.76478C1185.3 -112.578 1169.49 -288.677 1247.4 -302.979C1325.31 -317.281 1362.23 -193.059 1460.69 -73.4134",
    stroke: "url(#paint10_linear_96_553)",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1676.19 255.489C1651.89 325.866 1462.87 239.978 1321.87 277.294C1180.88 314.61 1106.22 449.996 999.411 434.607C892.597 419.218 789.113 293.466 809.165 203.425C829.217 113.384 1005.29 101.239 1095.66 2.40996C1186.03 -96.4189 1171.54 -257.843 1242.96 -270.953C1314.38 -284.063 1348.22 -170.193 1438.48 -60.518",
    stroke: "url(#paint11_linear_96_553)",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1632.37 239.657C1610.28 303.636 1438.44 225.555 1310.26 259.479C1182.08 293.403 1114.22 416.481 1017.12 402.491C920.012 388.501 825.935 274.181 844.164 192.326C862.393 110.47 1022.46 99.4291 1104.61 9.5847C1186.77 -80.2597 1173.6 -227.009 1238.53 -238.927C1303.45 -250.845 1334.22 -147.327 1416.27 -47.6225",
    stroke: "url(#paint12_linear_96_553)",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1588.55 223.824C1568.67 281.405 1414.01 211.133 1298.65 241.664C1183.29 272.195 1122.21 382.966 1034.82 370.375C947.427 357.783 862.758 254.896 879.164 181.226C895.57 107.556 1039.63 97.6189 1113.57 16.7589C1187.51 -64.101 1175.65 -196.175 1234.09 -206.902C1292.52 -217.628 1320.21 -124.462 1394.06 -34.7275",
    stroke: "url(#paint13_linear_96_553)",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1544.72 207.991C1527.06 259.175 1389.58 196.71 1287.04 223.849C1184.5 250.988 1130.21 349.451 1052.52 338.259C974.842 327.067 899.58 235.611 914.164 170.127C928.747 104.642 1056.8 95.8092 1122.52 23.9337C1188.25 -47.9418 1177.71 -165.341 1229.65 -174.876C1281.6 -184.41 1306.21 -101.596 1371.85 -21.8321",
    stroke: "url(#paint14_linear_96_553)",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1500.9 192.159C1485.44 236.944 1365.15 182.288 1275.43 206.035C1185.71 229.781 1138.2 315.936 1070.23 306.143C1002.26 296.35 936.403 216.326 949.163 159.027C961.924 101.728 1073.97 93.9995 1131.48 31.1084C1188.99 -31.7826 1179.77 -134.507 1225.22 -142.85C1270.67 -151.193 1292.2 -78.7301 1349.64 -8.93663",
    stroke: "url(#paint15_linear_96_553)",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1457.08 176.326C1443.83 214.713 1340.73 167.865 1263.82 188.219C1186.91 208.574 1146.2 282.421 1087.93 274.026C1029.67 265.632 973.226 197.041 984.163 147.927C995.101 98.8141 1091.14 92.1893 1140.43 38.2826C1189.73 -15.624 1181.82 -103.674 1220.78 -110.824C1259.74 -117.975 1278.2 -55.8646 1327.43 3.95834",
    stroke: "url(#paint16_linear_96_553)",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.26 160.493C1402.22 192.483 1316.3 153.443 1252.21 170.405C1188.12 187.367 1154.19 248.906 1105.64 241.911C1057.09 234.915 1010.05 177.756 1019.16 136.828C1028.28 95.9003 1108.31 90.3796 1149.39 45.4574C1190.47 0.53518 1183.88 -72.8394 1216.34 -78.7985C1248.81 -84.7576 1264.19 -32.9987 1305.21 16.8538",
    stroke: "url(#paint17_linear_96_553)",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.44 144.661C1360.61 170.253 1291.87 139.02 1240.6 152.59C1189.33 166.159 1162.18 215.391 1123.34 209.795C1084.5 204.199 1046.87 158.471 1054.16 125.729C1061.45 92.9864 1125.48 88.5699 1158.34 52.6321C1191.21 16.6944 1185.94 -42.0053 1211.91 -46.7726C1237.88 -51.5398 1250.18 -10.1327 1283 29.7492",
    stroke: "url(#paint18_linear_96_553)",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.62 128.828C1319 148.022 1267.44 124.598 1228.99 134.775C1190.54 144.952 1170.18 181.876 1141.05 177.679C1111.92 173.482 1083.69 139.186 1089.16 114.629C1094.63 90.0726 1142.65 86.7602 1167.3 59.8069C1191.94 32.8535 1187.99 -11.1712 1207.47 -14.7467C1226.95 -18.3221 1236.18 12.7332 1260.79 42.6447",
    stroke: "url(#paint19_linear_96_553)",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1281.8 112.995C1277.39 125.791 1243.02 110.175 1217.38 116.96C1191.75 123.745 1178.17 148.36 1158.75 145.562C1139.33 142.764 1120.52 119.9 1124.16 103.529C1127.81 87.1583 1159.82 84.95 1176.25 66.9811C1192.68 49.0122 1190.05 19.6624 1203.03 17.2787C1216.02 14.8951 1222.17 35.5987 1238.58 55.5397",
    stroke: "url(#paint20_linear_96_553)",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1237.98 97.163C1235.77 103.561 1218.59 95.7529 1205.77 99.1453C1192.95 102.538 1186.17 114.845 1176.46 113.446C1166.75 112.047 1157.34 100.616 1159.16 92.43C1160.98 84.2444 1176.99 83.1403 1185.21 74.1558C1193.42 65.1714 1192.1 50.4965 1198.6 49.3047C1205.09 48.1128 1208.17 58.4646 1216.37 68.4351",
    stroke: "url(#paint21_linear_96_553)",
    strokeOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_96_553",
    x1: 80347.3,
    y1: -24833.1,
    x2: 118163,
    y2: 98655.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEBE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE2BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_96_553",
    x1: 76749.4,
    y1: -23700.6,
    x2: 112847,
    y2: 94175.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEBE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE2BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_96_553",
    x1: 73151.5,
    y1: -22568.2,
    x2: 107530,
    y2: 89694.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEBE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE2BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_96_553",
    x1: 69553.7,
    y1: -21435.7,
    x2: 102213,
    y2: 85213.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEBE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE2BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_96_553",
    x1: 65955.8,
    y1: -20303.2,
    x2: 96896.2,
    y2: 80733.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEBE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE2BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_96_553",
    x1: 62357.9,
    y1: -19170.7,
    x2: 91579.4,
    y2: 76252.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEBE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE2BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_96_553",
    x1: 58760.1,
    y1: -18038.3,
    x2: 86262.7,
    y2: 71771.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEBE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE2BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_96_553",
    x1: 55162.2,
    y1: -16905.8,
    x2: 80945.9,
    y2: 67291.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEBE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE2BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_96_553",
    x1: 51564.3,
    y1: -15773.3,
    x2: 75629.1,
    y2: 62810.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEBE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE2BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_96_553",
    x1: 47966.5,
    y1: -14640.8,
    x2: 70312.3,
    y2: 58329.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEBE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE2BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_96_553",
    x1: 44368.6,
    y1: -13508.4,
    x2: 64995.5,
    y2: 53849.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEBE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE2BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_96_553",
    x1: 40770.7,
    y1: -12375.9,
    x2: 59678.8,
    y2: 49368.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEBE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE2BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_96_553",
    x1: 37172.9,
    y1: -11243.4,
    x2: 54362,
    y2: 44887.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEBE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE2BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_96_553",
    x1: 33575,
    y1: -10110.9,
    x2: 49045.2,
    y2: 40407.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEBE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE2BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_96_553",
    x1: 29977.1,
    y1: -8978.47,
    x2: 43728.4,
    y2: 35926.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEBE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE2BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_96_553",
    x1: 26379.2,
    y1: -7845.99,
    x2: 38411.6,
    y2: 31445.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEBE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE2BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_96_553",
    x1: 22781.4,
    y1: -6713.52,
    x2: 33094.9,
    y2: 26965.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEBE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE2BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_96_553",
    x1: 19183.5,
    y1: -5581.04,
    x2: 27778.1,
    y2: 22484.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEBE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE2BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_96_553",
    x1: 15585.6,
    y1: -4448.57,
    x2: 22461.3,
    y2: 18004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEBE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE2BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_96_553",
    x1: 11987.8,
    y1: -3316.09,
    x2: 17144.5,
    y2: 13523.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEBE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE2BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_96_553",
    x1: 8389.9,
    y1: -2183.62,
    x2: 11827.7,
    y2: 9042.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEBE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE2BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_96_553",
    x1: 4792.03,
    y1: -1051.14,
    x2: 6510.94,
    y2: 4561.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEBE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE2BAE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96_553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1568,
    height: 1320,
    fill: "white",
    transform: "translate(0 -257.876) rotate(-17.0262)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground2);
export default __webpack_public_path__ + "static/media/background-2.6d3b757cd8ba6bb07dbe7fa4a91c4778.svg";
export { ForwardRef as ReactComponent };